// extracted by mini-css-extract-plugin
module.exports = {"checboxLabelClassName":"CustomColumnFormFields_checboxLabelClassName__XVhWx"};